import { select, call, takeLatest, put } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import { store } from 'modules';
import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

const DatasetsToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const fetchDatasets = function* ({ datasetName, pageSize, pageNumber }) {
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);

  const datasets = yield call(api.fetchDatasets, datasetName, {
    pageSize,
    pageNumber,
    token,
    publisherId,
  });

  return datasets;
};

const fetchDatasetsRequest = function* ({ payload }) {
  const { datasetName = 'default', pageSize, pageNumber } = payload;

  yield put($ui.setTrue(UI.Datasets.IsFetching)());

  try {
    const datasets = yield* fetchDatasets({ datasetName, pageSize, pageNumber });
    yield put(actions.setDatasets(datasets));
  } catch {
    DatasetsToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message: 'Something went wrong while fetching datasets',
      action: {
        text: 'Try again',
        onClick: () => {
          store.dispatch(actions.fetchDatasets(pageSize, pageNumber, datasetName));
        },
      },
    });
  }

  yield put($ui.setFalse(UI.Datasets.IsFetching)());
};

export const fetchDatasetsSaga = function* () {
  yield takeLatest(actions.fetchDatasets, fetchDatasetsRequest);
};
